import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";

import LoadingSpinner from "components/LoadingSpinner";
import PresetCard from "components/PresetCard";

const FeaturedPacks = ({ featured_packs }) => {
  // Don't modify the original array, make copies instead
  if (!featured_packs || featured_packs.length === 0) {
    return <LoadingSpinner message="Loading Packs..." />;
  }

  // Create safe copies of the data to avoid mutating the state
  const packs = [...featured_packs];
  const first_pack = packs.length > 0 ? packs[0] : null;
  const remaining_packs = packs.slice(1);
  const row_1 = remaining_packs.slice(0, 2);
  const row_2 = remaining_packs.slice(2, 4);

  return (
    <div className="featured-packs-container mb-5">
      <Row>
        <Col md={12} lg={6} className="d-flex align-items-stretch mb-4">
          {first_pack && (
            <PresetCard 
              cardSize="card h-100 w-100 mega-card" 
              mega={true} 
              preset_pack={first_pack} 
            />
          )}
        </Col>

        <Col md={12} lg={6}>
          <Row className="mb-4">
            {row_1.map((preset_pack) => (
              <Col sm={6} key={preset_pack.id} className="d-flex align-items-stretch mb-4">
                <PresetCard 
                  preset_pack={preset_pack} 
                  cardSize="card h-100 w-100 medium-card" 
                />
              </Col>
            ))}
          </Row>

          <Row>
            {row_2.map((preset_pack) => (
              <Col sm={6} key={preset_pack.id} className="d-flex align-items-stretch">
                <PresetCard 
                  preset_pack={preset_pack} 
                  cardSize="card h-100 w-100 medium-card" 
                />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  featured_packs: state.featured_packs
});

export default connect(mapStateToProps)(FeaturedPacks);
